/**
 * Every number in the app is an Indian mobile: exactly 10 digits.
 * Mirrors isValidPhone() in lib.js — keep the two in step.
 */
export const PHONE_LENGTH = 10;

export const isValidPhone = (value: string): boolean => /^\d{10}$/.test(value.trim());

/** For onChange: drop anything that isn't a digit and cap the length. */
export const sanitizePhone = (value: string): string => value.replace(/\D/g, '').slice(0, PHONE_LENGTH);

const COUNTRY_CODE = '91';

/**
 * A wa.me deep link, or null when the number can't be dialled — callers hide the
 * button rather than render a link that opens WhatsApp on nothing.
 *
 * wa.me wants country code + digits, no "+" and no separators. Stored numbers are
 * bare 10-digit mobiles, but a manager may have typed one that already carries the
 * 91, so both shapes are accepted.
 */
export const whatsappLink = (phone: string, message: string): string | null => {
  const digits = (phone ?? '').replace(/\D/g, '');
  const full =
    digits.length === PHONE_LENGTH
      ? COUNTRY_CODE + digits
      : digits.length === COUNTRY_CODE.length + PHONE_LENGTH && digits.startsWith(COUNTRY_CODE)
        ? digits
        : null;
  return full ? `https://wa.me/${full}?text=${encodeURIComponent(message)}` : null;
};
